import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { BOOKING_URL, INSTAGRAM_URL, PHONE, PHONE_TEL, EMAIL, ADDRESS_LINE_1, ADDRESS_LINE_2 } from "@/data/content";
import { SP_WIDGET_ATTRS } from "./BookingButton";

export default function Footer() {
  return (
    <footer
      className="border-t mt-32"
      style={{ background: "var(--sano-bg-2)", borderColor: "var(--sano-border)" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif-display text-4xl mb-4">Sano Acupuncture</div>
          <p className="text-sm max-w-sm leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
            Acupuncture, cupping, facial acupuncture and yoni herbal steam in the
            Bronx. Slow medicine for fast lives.
          </p>
        </div>

        <div>
          <div className="eyebrow mb-4">Visit</div>
          <div className="flex items-start gap-2 text-sm mb-2">
            <MapPin size={14} strokeWidth={1.5} className="mt-0.5" />
            <span>
              {ADDRESS_LINE_1}<br/>{ADDRESS_LINE_2}
            </span>
          </div>
          <div className="flex items-start gap-2 text-sm mb-2">
            <Phone size={14} strokeWidth={1.5} className="mt-0.5" />
            <a href={PHONE_TEL} className="hover:underline" data-testid="footer-phone">{PHONE}</a>
          </div>
          <div className="flex items-start gap-2 text-sm">
            <Mail size={14} strokeWidth={1.5} className="mt-0.5" />
            <a href={`mailto:${EMAIL}`} className="hover:underline" data-testid="footer-email">{EMAIL}</a>
          </div>
        </div>

        <div>
          <div className="eyebrow mb-4">Connect</div>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noreferrer"
            {...SP_WIDGET_ATTRS}
            className="block text-sm mb-2 hover:underline"
            data-testid="footer-book-link"
          >
            Request appointment →
          </a>
          <a href="#rental" className="block text-sm mb-2 hover:underline" data-testid="footer-rental">
            Rent a room →
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm hover:underline"
            data-testid="footer-instagram"
          >
            <Instagram size={14} strokeWidth={1.5} /> @sanoacupuncture
          </a>
        </div>
      </div>

      <div
        className="border-t py-6 text-center text-xs"
        style={{ borderColor: "var(--sano-border)", color: "var(--sano-ink-2)" }}
      >
        © {new Date().getFullYear()} Sano Acupuncture · Joannie Campuzano Cepeda, L.Ac.
      </div>
    </footer>
  );
}
